import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import humanTime from 'flarum/common/helpers/humanTime';
import ItemList from 'flarum/common/utils/ItemList';
import Button from 'flarum/common/components/Button';
import { markRead } from '../utils/readState';
export default class DialogListItem extends Component {
  view(vnode) {
    const dialog = this.attrs.dialog;
    const recipient = dialog.recipient();
    const unread = dialog.unreadCount();
    const actions = this.attrs.actions ? this.actionItems().toArray() : [];
    return m("li", {
      className: classList('DialogListItem', {
        'DialogListItem--unread': unread,
        'DialogListItem--actions': actions.length,
        active: this.attrs.active
      })
    }, m(Link, {
      href: app.route.dialog(dialog),
      className: classList('DialogListItem-button', {
        active: this.attrs.active
      })
    }, m("div", {
      className: "DialogListItem-avatar"
    }, m(Avatar, {
      user: recipient
    }), !!unread && m("div", {
      className: "Bubble Bubble--primary"
    }, m("span", {
      "aria-hidden": "true"
    }, unread), m("span", {
      className: "sr-only"
    }, app.translator.trans('flarum-messages.forum.dialog_list.unread_count_text', {
      count: unread
    })))), m("div", {
      className: "DialogListItem-content"
    }, m("div", {
      className: "DialogListItem-title"
    }, username(recipient), humanTime(dialog.lastMessageAt())), m("div", {
      className: "DialogListItem-lastMessage"
    }, this.preview()))), !!actions.length && m("div", {
      className: "DialogListItem-actions"
    }, actions));
  }

  /** The last message, said to be the member's own when it is. */
  preview() {
    const lastMessage = this.attrs.dialog.lastMessage();
    if (!lastMessage) return '';
    const content = lastMessage.contentPlain()?.slice(0, 80) ?? '';
    return lastMessage.user() === app.session.user ? app.translator.trans('flarum-messages.forum.dialog_list.own_last_message_preview', {
      content
    }) : content;
  }
  actionItems() {
    const items = new ItemList();
    const dialog = this.attrs.dialog;
    const lastMessageId = dialog.messageRelationshipId('lastMessage');

    // Nothing to mark on a dialog that is read, or one with no messages.
    if (dialog.unreadCount() && lastMessageId) {
      items.add('markAsRead', m(Button, {
        className: "Notification-action Button Button--link",
        icon: "fas fa-check",
        "aria-label": app.translator.trans('flarum-messages.forum.dialog_list.mark_as_read_tooltip'),
        onclick: () => {
          markRead(dialog, Number(lastMessageId)).catch(() => {}).finally(() => m.redraw());
        }
      }), 100);
    }
    return items;
  }
}
flarum.reg.add('flarum-messages', 'forum/components/DialogListItem', DialogListItem);